import { Menu, MenuButton, MenuList, IconButton, MenuDivider, MenuItem } from '@chakra-ui/react'
import { IExpert } from '@/shared/IExpert'
import { FiEdit2, FiExternalLink, FiMail, FiMoreHorizontal, FiX } from 'react-icons/fi'
import { runtimeConfig } from '../services/RuntimeConfig'

import { createColumnHelper } from "@tanstack/react-table";
import { DataTable } from "./DataTable";
import { formatDateFromNow } from '@/shared/parse';
import { HighlightedText } from '../components/HighlightedText';

export const ExpertTable = (props: {
  filter: string[];
  experts: IExpert[];
  onDeleteExpert: (expert: IExpert) => void;
  onSendExpertInvitation: (expert: IExpert) => Promise<void>;
  onEditExpert: (expert: IExpert) => void;
}) => {

  const openSharePointFolder = (expert: IExpert) => {
    let url = `${runtimeConfig.spSiteUrl}/Lists/Experts/DispForm.aspx?ID=${expert.id}`;
    window.open(url, `expert-${expert.id}`);
  }

  const columnHelper = createColumnHelper<IExpert>();

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      cell: (info) => {
        const expert = info.row.original;
        return (
          <Menu>
            <MenuButton as={IconButton} variant='ghost' icon={<FiMoreHorizontal />} cursor='pointer' boxSize="10" />
            <MenuList fontSize='medium' lineHeight={1.5}>
              <MenuItem icon={<FiEdit2 />} onClick={() => props.onEditExpert(expert)}>Edit...</MenuItem>
              <MenuDivider />
              <MenuItem icon={<FiMail />} onClick={() => props.onSendExpertInvitation(expert)}>Resend Invitation</MenuItem>
              <MenuItem icon={<FiExternalLink />} onClick={() => openSharePointFolder(expert)}>Open in SharePoint...</MenuItem>
              <MenuDivider />
              <MenuItem icon={<FiX />} onClick={() => props.onDeleteExpert(expert)}>Delete...</MenuItem>
            </MenuList>
          </Menu>
        )
      },
      enableSorting: false,
      enableHiding: false,
      size: 10
    }),
    columnHelper.accessor('name', {
      cell: (info) => {
        const expert = info.row.original;
        return (
          <HighlightedText text={expert.name} filter={props.filter} />
        )
      },
      header: "External Reviewer Name"
    }),
    columnHelper.accessor('email', {
      cell: (info) => {
        const expert = info.row.original;
        return <HighlightedText text={expert.email} filter={props.filter} />
      },
      header: "External Reviewer Email"
    }),
    columnHelper.accessor('role', {
      cell: (info) => {
        const expert = info.row.original;
        const roleDisplay = expert.role === 'staff' ? 'Staff' : 'Reviewer';
        return <HighlightedText text={roleDisplay} filter={props.filter} />
      },
      header: "Role"
    }),

    columnHelper.accessor("modified", {
      cell: (info) => {
        const course = info.row.original;
        return formatDateFromNow(course.modified)
      },
      header: "Modified"
    }),
    columnHelper.accessor("modifiedBy", {
      cell: (info) => {
        const course = info.row.original;
        return course.modifiedBy?.name
      },
      header: "Modified By"
    })

  ];


  return (
    <DataTable
      onRowClick={props.onEditExpert}
      emptyLabel='No experts to here yet'
      columns={columns}
      data={props.experts}
    />
  )
}